import React, {Component} from "react";
import {SortableTableHeader} from "../../components/table/sortable-table-header";

export default class SupplierTableHeader extends Component {

  static Layout = [
    { column: "utility", },
    { column: "supplierReference", width: 2, name: "Serial Ref." },
    { column: "invoiceType", name: "type" },
    { column: "billingFrequency", name: "Billing Freq." },
    { column: "dateFrom", name: "From" },
    { column: "dateTo", name: "To" },
    { column: "supplier", width: 2 },
    { column: "units" },
    { column: "nett" },
    { column: "gross" },
    { column: "empty", width: 2 },
    { column: "empty", width: 2 }

  ];

  render() {
    return (
        <SortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={SupplierTableHeader.Layout}/>
    )
  }

}